// A saved row can recalculate these values on focus without an Admin edit.
export const derivedRowDraftFields = new Set(['availableQuantity', 'calculatedHours', 'totals']);
const calculatedDraftFields = new Set(['endDate', ...derivedRowDraftFields]);

export const rowInputSignature = (values: Record<string, unknown>) => JSON.stringify(
  Object.keys(values).filter(field => !calculatedDraftFields.has(field)).sort()
    .map(field => [field, values[field]])
);

/** The same display defaults drive the editor and legacy buffer comparison. */
export const quoteRowInputDefaults = (position: any, editorMode = 'saved', initialTemporalValues: Record<string, any> = {}) => ({
  shiftNumber: position?.shiftNumber || '1',
  startDate: String(position?.startDate || '').split('T')[0],
  endDate: String(position?.endDate || '').split('T')[0],
  startTime: position?.startTime ?? (editorMode === 'new' ? '' : '08:00'),
  endTime: position?.endTime ?? (editorMode === 'new' ? '' : '19:00'),
  ...initialTemporalValues,
  position: position?.position || '',
  quantity: position?.quantity ?? (editorMode === 'new' ? '' : 1),
  availableQuantity: position?.availableQuantity || 0,
  area: position?.area || '',
  toolsGear: position?.toolsGear || '',
  notes: position?.notes || '',
  rateType: position?.rateType || '',
  callType: position?.callType ?? (editorMode === 'new' ? '' : 'Setup'),
  mealBreak: position?.mealBreak ?? (editorMode === 'new' ? '' : 'N/A'),
  rate: position?.clientRatePending ? '' : position?.rate ?? 0,
  clientRatePending: Boolean(position?.clientRatePending),
  desiredRate: editorMode === 'new' ? position?.desiredRate ?? '' : position?.desiredRate || 0,
  calculatedHours: position?.calculatedHours || 10,
  registerHours: position?.registerHours || 0,
  overTimeHours: position?.overTimeHours || 0,
  DoubleTimeHours: position?.DoubleTimeHours || 0,
  addOns: position?.addOns || 0,
  miscFees: position?.miscFees || 0,
  agreementLaborTotal: position?.agreementLaborTotal,
  manualCalculation: Boolean(position?.manualCalculation),
  manualHours: Boolean(position?.manualHours),
  manualRate: Boolean(position?.manualRate),
  manualTotal: position?.manualTotal,
  manualOvertimeFactor: position?.manualOvertimeFactor,
  manualDoubleTimeFactor: position?.manualDoubleTimeFactor,
  totals: position?.clientRatePending ? null : position?.totals || 0
});
